"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

var _isEqual = _interopRequireDefault(require("lodash/isEqual"));

var _popup = _interopRequireDefault(require("../popup"));

var _pickerView = _interopRequireDefault(require("../picker-view"));

var _parseProps = _interopRequireDefault(require("../picker-view/utils/parseProps"));

var _removeFnFromProps = _interopRequireDefault(require("../picker-view/utils/removeFnFromProps"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Picker = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Picker, _Component);

  var _super = _createSuper(Picker);

  function Picker() {
    var _this;

    (0, _classCallCheck2.default)(this, Picker);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = _objectSpread(_objectSpread({}, _parseProps.default.getSource(_this.props)), {}, {
      stopScroll: false
    });

    _this.onChange = function (selected) {
      var _this$props = _this.props,
          valueMember = _this$props.valueMember,
          onChange = _this$props.onChange;
      var value = selected.map(function (item) {
        return item[valueMember];
      });

      _this.setState({
        value: value,
        objValue: selected
      });

      if (typeof onChange === 'function') {
        onChange(selected);
      }
    };

    _this.onCancel = function () {
      var onCancel = _this.props.onCancel;
      var _this$state = _this.state,
          _this$state$tempValue = _this$state.tempValue,
          tempValue = _this$state$tempValue === void 0 ? [] : _this$state$tempValue,
          _this$state$tempObjVa = _this$state.tempObjValue,
          tempObjValue = _this$state$tempObjVa === void 0 ? [] : _this$state$tempObjVa;

      _this.setState({
        value: tempValue,
        objValue: tempObjValue
      });

      if (typeof onCancel === 'function') {
        onCancel();
      }
    };

    _this.onOk = function () {
      var onOk = _this.props.onOk;

      _this.setState({
        stopScroll: true
      }, function () {
        _this.setState({
          stopScroll: false
        }, function () {
          if (typeof onOk === 'function') {
            onOk(_this.state.objValue);
          }
        });
      });
    };

    return _this;
  }

  (0, _createClass2.default)(Picker, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          prefixCls = _this$props2.prefixCls,
          className = _this$props2.className,
          cancelText = _this$props2.cancelText,
          okText = _this$props2.okText,
          title = _this$props2.title,
          locale = _this$props2.locale,
          maskClosable = _this$props2.maskClosable,
          mountContainer = _this$props2.mountContainer,
          destroy = _this$props2.destroy,
          onOk = _this$props2.onOk,
          onCancel = _this$props2.onCancel,
          visible = _this$props2.visible,
          others = (0, _objectWithoutProperties2.default)(_this$props2, ["prefixCls", "className", "cancelText", "okText", "title", "locale", "maskClosable", "mountContainer", "destroy", "onOk", "onCancel", "visible"]);
      var _this$state2 = this.state,
          value = _this$state2.value,
          _this$state2$stopScro = _this$state2.stopScroll,
          stopScroll = _this$state2$stopScro === void 0 ? false : _this$state2$stopScro;

      var noop = function noop() {};

      return /*#__PURE__*/_react.default.createElement(_popup.default, {
        className: className,
        visible: visible,
        onMaskClick: maskClosable ? this.onCancel : noop,
        mountContainer: mountContainer,
        destroy: destroy
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: prefixCls,
        onClick: function onClick(e) {
          e.stopPropagation();
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "".concat(prefixCls, "__header")
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "".concat(prefixCls, "__cancel"),
        onClick: this.onCancel
      }, cancelText || locale.cancelText), /*#__PURE__*/_react.default.createElement("div", {
        className: "".concat(prefixCls, "__title")
      }, title || locale.title), /*#__PURE__*/_react.default.createElement("div", {
        className: "".concat(prefixCls, "__submit"),
        onClick: this.onOk
      }, okText || locale.okText)), /*#__PURE__*/_react.default.createElement(_pickerView.default, (0, _extends2.default)({}, others, {
        value: value,
        onChange: this.onChange,
        stopScroll: stopScroll
      }))));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      if (!(0, _isEqual.default)((0, _removeFnFromProps.default)(props, ['onOk', 'onCancel', 'onChange']), (0, _removeFnFromProps.default)(state.prevProps, ['onOk', 'onCancel', 'onChange']))) {
        return _objectSpread(_objectSpread({
          prevProps: props
        }, _parseProps.default.getSource(props)), {}, {
          tempValue: _parseProps.default.getSource(props).value,
          tempObjValue: _parseProps.default.getSource(props).objValue
        });
      }

      return null;
    }
  }]);
  return Picker;
}(_react.Component);

exports.default = Picker;
Picker.defaultProps = {
  dataSource: [],
  prefixCls: 'za-picker',
  valueMember: 'value',
  cols: Infinity,
  maskClosable: true,
  itemRender: function itemRender(data) {
    return data.label;
  },
  destroy: false
};